












































import { Component, Vue } from "vue-property-decorator";
import { WalletCreate, Currency, UserProfile } from "@/interfaces";
import {
  dispatchGetWallets,
  dispatchCreateWallet,
  dispatchGetCurrencies
} from "@/store/wallet/actions";
import { dispatchGetUsers } from "@/store/admin/actions";
import { readCurrencies } from "@/store/wallet/getters";
import { readAdminUsers } from "@/store/admin/getters";

@Component
export default class AdminCreateWallet extends Vue {
  public valid = false;
  public name: string | null = "";
  public currency = "";
  public address = "";
  public full_name = "";

  public async mounted() {
    await Promise.allSettled([
      dispatchGetWallets(this.$store),
      dispatchGetCurrencies(this.$store),
      dispatchGetUsers(this.$store)
    ]);
    this.reset();
  }

  get currency_names() {
    const currency_names: string[] = [];
    readCurrencies(this.$store)?.forEach(currency => {
      currency_names.push(currency.name);
    });
    console.log(currency_names);
    return currency_names;
  }

  get full_names() {
    const full_names: string[] = [];
    readAdminUsers(this.$store)?.forEach(user => {
      let name = user.id.toString() + "-";
      if (user.full_name) name += user.full_name;
      else if (user.mobile) name += user.mobile;
      else if (user.email) name += user.email;
      full_names.push(name);
    });
    console.log(full_names);
    return full_names;
  }
  public reset() {
    this.name = "";
    this.currency = "";
    this.address = "";
    this.full_name = "";
    this.$validator.reset();
  }

  public cancel() {
    this.$router.back();
  }

  public async submit() {
    console.log("submit");
    if (
      (await this.$validator.validateAll()) &&
      this.currency &&
      this.address
    ) {
      console.log("if");
      const updatedWallet: WalletCreate = {
        currency: readCurrencies(this.$store)?.find(
          (currency: Currency) => currency.name === this.currency
        )!.id,
        address: this.address,
        owner_id: readAdminUsers(this.$store).find(
          (user: UserProfile) => user.id === +this.full_name.split("-")[0]
        )!.id
      };
      if (this.name) {
        updatedWallet.name = this.name;
      }
      await dispatchCreateWallet(this.$store, updatedWallet);
      this.$router.push("/main/wallets");
    }
  }
}
